module.exports = __webpack_public_path__ + "img/ja.ce5fd254.svg";